import React, { Component } from 'react';
import RegisterSuccessed from './register-successed.jsx'
import axios from 'axios';
import qs from 'qs';

import { NavBar, List, Button, InputItem, Toast, Modal } from 'antd-mobile';
import { WingBlank, WhiteSpace } from 'antd-mobile';
import captcha from '../captcha/captcha.jsx';

const isios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

let time1
export default class RegisterForm extends Component {
    constructor() {
        super()
        this.state = {
            source: source,//view 提供 从url中取出来的 表明用户来源，
            username: null,
            phone: null,
            authCode: null,
            authCodeSrc: '/?g=mobile&c=user&a=captcha',
            messageCode: null,
            password: null,
            passwordConfirm: null,
            errorText: '',
            isCompanyLegal: false,
            isPhoneLegal: false,
            isWaitingMessage: false,
            isCounting: false,
            countDownNumber: null,
            isRegisterSuccessed: false,

            modalShow: false,
            isCompanySignin: true,
            companyName: "",
        }
        this.checkoutPerson = ::this.checkoutPerson;
        this.checkoutCompany = ::this.checkoutCompany;
        this.onChangeCompanyName = ::this.onChangeCompanyName;
        this.checkCompanyNameLegality = ::this.checkCompanyNameLegality;
        this.onCloseModal = ::this.onCloseModal;
        this.sendCode = ::this.sendCode;
        this.checkUsernameLegality = ::this.checkUsernameLegality;
    }
    onChangeUsername = (newValue) => {
        this.setState({
            username: newValue
        })
    }
    onChangePhone = (newValue) => {
        this.setState({
            phone: newValue
        })
        
    }
    onChangeMessageCode = (newValue) => {
        newValue = newValue.replace(/(\s*)/g, "")
        this.setState({
            messageCode: newValue
        })
    }
    onChangePassword = (newValue) => {
        newValue = newValue.replace(/(\s*)/g, "")
        this.setState({
            password: newValue
        })
    }
    onChangePasswordConfirm = (newValue) => {
        newValue = newValue.replace(/(\s*)/g, "")
        this.setState({
            passwordConfirm: newValue
        })
    }
    onChangeCompanyName(value) {
    this.setState({
      companyName: value,
    });
  }

    getAuthCode = () => {
        this.resetCaptcha();
    }

    checkCompanyNameLegality() {
      const { companyName } = this.state;
      if(!companyName) {
        this.setState({
          errorText: '公司名不能为空',
        });
      } else if (this.getLength(companyName) < 4) {
        this.setState({
          errorText: '公司名长度不在范围内',
        })
      } else {
        this.setState({
          errorText: '',
        })
        return true
      }
    }
    checkUsernameLegality() {
        const { username } = this.state,
          usernameReg = new RegExp('^[a-zA-Z0-9_\u4e00-\u9fa5]+$');
        if (!username) {
            this.setState({
                errorText: '用户名不能为空'
            })
        } else if (!usernameReg.test(username)) {
            this.setState({
              errorText: '用户名包含特殊字符'
            })
        } else if (this.getLength(username) < 4) {
            this.setState({
                errorText: '用户名长度不在范围内'
            })
        }
        else if (/\s/.test(username)) {
            this.setState({
                errorText: '用户名不能存在空格'
            })
        } else {
          this.setState({
            errorText: ''
          })
          return true
        }
    }
    
    checkPhoneLegality = () => {
        let { phone } = this.state,
            phoneReg = new RegExp('^1[0-9]{10}$')
        if (!phone) {
          this.setState({
            errorText: '手机号码不能为空'
          })
        } else if (phone.length < 11) {
          this.setState({
            errorText: '请填写正确手机号'
          })
        } else if (!phoneReg.test(phone)) {
          this.setState({
            errorText: '手机号格式错误!'
          })
        } else {
          this.setState({
            errorText: '',
          })
          return true;
        }
    }

    checkMessageCodeLegality = () => {
        let { messageCode } = this.state
        if (!messageCode) {
            this.setState({
                errorText: '请填写短信验证码'
            })
        } else {
          this.setState({
            errorText: '',
          })
          return true
        }
    }
    
    checkPasswordLegality = () => {
        let { password } = this.state
        if (!password) {
            this.setState({
                errorText: '请输入密码'
            })
        } else if (password.length < 6) {
            this.setState({
                errorText: '密码少于6位数'
            })
        } else {
          this.setState({
            errorText: '',
          })
          return true
        }
    }
    
    checkPasswordConfirmLegality = () => {
        let { password, passwordConfirm } = this.state
        
        if (password !== passwordConfirm) {
            this.setState({
                errorText: '密码和确认密码必须一致'
            })
        } else {
          this.setState({
            errorText: '',
          })
          return true
        }
    }

    onChangeAuthCode= (e) => {
      const newValue = e.replace(/(\s*)/g, "")
      this.setState({
            authCode: newValue
        })
    }
    register = () => {
        let { source,username, password, phone, messageCode, passwordConfirm, isCompanySignin, companyName, sig, sessionId, token } = this.state,
            _self = this,
            postData = { username, password, phone ,source, sig, sessionId, token, scene: 'ic_register'}
        postData.authCode = messageCode;
        if (isCompanySignin) {
            postData.type = 3;
            postData.nick = companyName;
        } else {
            postData.type = 1;
        }
        if (isCompanySignin && !companyName) {
            Toast.fail("请填写完整信息", 2);
            return
        }
        if (!username || !phone || !messageCode || !password || !passwordConfirm) {
            Toast.fail("请填写完整信息", 2);
            return
        }

        if (isCompanySignin && !this.checkCompanyNameLegality()) {
          return
        }
        if (!this.checkUsernameLegality() || !this.checkPhoneLegality() || !this.checkMessageCodeLegality() || !this.checkPasswordLegality() ||
          !this.checkPasswordConfirmLegality()) {
          return
        }
        axios.post('/?g=mobile&c=user&a=ajaxregister', qs.stringify(postData)).then((res) => {
            let data = res.data
            if (data.status == 'y') {
                Toast.success(data.info, 2)

                this.setState({
                    isRegisterSuccessed: true
                })
            } else {
                Toast.fail(data.info, 2);
                this.setState({
                  errorText: data.info,
                })
            }
        })
    }

    getMessageCode = () => {
        let { phone } = this.state;
        if (!this.checkPhoneLegality()) {
          Toast.fail('请填写正确手机号', 1);
          return
        }
        axios.post('/session.php?a=checkPhoneExistance', qs.stringify({ phone: phone})).then((res) => {
            const data = res.data
            if (data.status == 'n') {
              Toast.fail('手机号已被注册', 1);
              this.setState({
                errorText: '手机号已被注册',
              })
              return
            } else {
              this.setState({
                errorText: '',
              })
            }
            this.setState({
              modalShow: true,
            }, this.initCaptcha);
            // this.getAuthCode();
        })
    }
    
    countDown = () => {
        let _self = this
        this.setState({
            countDownNumber: 60
        }, () => {
            time1 = setInterval(_self.setCountDownNumber, 1000)
        })
        
    }

    initCaptcha() {
        captcha({
            renderTo: 'captcha-mobileregister',
            scene: 'ic_register',
            isH5: true,
            width: '100%',
            height: '1.2rem',
            outerThis: this,
            callback: (data) => {
                this.setState({
                    sig: data.sig,
                    token: data.token,
                    sessionId: data.sessionId
                });
                this.sendCode();
            }
        })
    }
    
    setCountDownNumber = () => {
        let { countDownNumber } = this.state
        
        if (countDownNumber <= 0) {
            clearInterval(time1)
            this.setState({
                isCounting: false
            })
            return
        }
        if (countDownNumber && countDownNumber > 0) {
            this.setState({
                countDownNumber: countDownNumber - 1
            })
        }
    }
    
    getLength = (str) => {
        return str.replace(/[^\x00-\xff]/igm, '**').length;
    }
    
    historyBack = () => {
        window.history.back()
    }

    checkoutPerson() {
      this.setState({
        isCompanySignin: false,
        errorText: '',
      });
    }
    checkoutCompany() {
      this.setState({
        isCompanySignin: true,
        errorText: '',
      });
    }
    onCloseModal() {
        this.setState({
          modalShow: false,
          authCode: "",
        });
    }
    sendCode() {
        const { phone, sig, sessionId, token } = this.state;
        if (!sig || !sessionId || !token) {
            return;
        }
        const postData = {
            phone: phone,
            sig,
            sessionId,
            token,
            scene: 'ic_register'
        }
          this.setState({
            isWaitingMessage: true
          }, () => {
            axios.post('/?g=mobile&c=user&a=ajaxSendAuthCode', qs.stringify(postData)).then((res) => {
              this.setState({
                isWaitingMessage: false
              })
              let data = res.data
              if (data.status == 'y') {
                Toast.success('验证码已发送', 2);
                this.setState({
                  isCounting: true,
                  modalShow: false,
                  authCode: "",
                }, () => {
                  this.countDown()
                })
              } else {
                this.setState({
                  authCode: "",
                }, () => {
                  this.getAuthCode()
                  Toast.fail(data.info, 2);
                })
              }
            })
          })
    }

    render() {
        let { source, username, phone, messageCode, authCode, authCodeSrc, password, passwordConfirm, errorText, isCounting, countDownNumber,
          isRegisterSuccessed, isCompanySignin, companyName, modalShow } = this.state
        let messageCodeNode = <div id="messageCode">
            {isCounting ? <div className="countDown">已发送{countDownNumber}秒</div> :
                <div onClick={this.getMessageCode}>发送验证码</div>}
        </div>
        let loginUrl = source==='sony'? "/?g=mobile&c=user&a=login&source=sony" :"/?g=mobile&c=user&a=login"
        return (
            <div id="registerForm">
                <NavBar
                    leftContent="返回"
                    mode="light"
                    onLeftClick={this.historyBack}
                >注册目睹</NavBar>
                {
                    isRegisterSuccessed
                        ?
                        <RegisterSuccessed
                            source={this.state.source}
                        />
                        :
                        <div className="form-wrap">
                            <div className="banner"><img src="mobile/assets/img/banner.png" alt=""/></div>
                            <div className="list-type">
                                <span onClick={this.checkoutCompany} className={isCompanySignin ? "hover" : ""}>企业用户</span>
                                <span onClick={this.checkoutPerson} className={isCompanySignin ? "" : "hover"}>个人用户</span>
                            </div>
                            <List className="my-list">
                              {
                                isCompanySignin &&
                                  <InputItem
                                    placeholder="请填写公司名"
                                    value={companyName}
                                    maxLength={80}
                                    onChange={this.onChangeCompanyName}
                                    onBlur={this.checkCompanyNameLegality}
                                    clear
                                    autoFocus={true}
                                  >公司名</InputItem>
                              }
                              <InputItem
                                placeholder="请填写用户名"
                                maxLength={40}
                                value={username}
                                onChange={this.onChangeUsername}
                                onBlur={this.checkUsernameLegality}
                                clear
                                autoFocus={true}
                              >用户名</InputItem>
                              <InputItem
                                placeholder="请输入手机号"
                                value={phone}
                                type="number"
                                onChange={this.onChangePhone}
                                onBlur={this.checkPhoneLegality}
                                clear
                              >手机号</InputItem>
                              <InputItem
                                className="messageCode-Wrap"
                                placeholder="请输入手机验证码"
                                value={messageCode}
                                maxLength={8}
                                type="number"
                                onChange={this.onChangeMessageCode}
                                onBlur={this.checkMessageCodeLegality}
                                extra={messageCodeNode}
                                clear
                              >验证码</InputItem>
                              <InputItem
                                placeholder="请设置6位以上的密码"
                                value={password}
                                maxLength={20}
                                type="password"
                                onChange={this.onChangePassword}
                                onBlur={this.checkPasswordLegality}
                                clear
                              >密码</InputItem>
                              <InputItem
                                placeholder="请再次输入密码"
                                value={passwordConfirm}
                                maxLength={20}
                                type="password"
                                onChange={this.onChangePasswordConfirm}
                                onBlur={this.checkPasswordConfirmLegality}
                                clear
                              >确认密码</InputItem>
                            </List>
                            <WingBlank size="lg">
                                <p className="error-line">{errorText}</p>
                            </WingBlank>
                            <WingBlank>
                                <Button type="primary" onClick={this.register}>完成</Button>
                            </WingBlank>
                            <WhiteSpace size="sm"/>
                            {/* <WingBlank size="lg">
                                <p className="login-line">已有账号 <a href={loginUrl}>登录</a></p>
                            </WingBlank> */}
                            <p className="agreement-line">
                                点击完成即表示已阅读并接受
                                <span className="user-agreement" onClick={this.props.onClick}>《目睹直播平台服务条款》</span>
                            </p>
                            {modalShow && <Modal
                            visible={modalShow}
                            onClose={this.onCloseModal}
                            transparent
                            title="安全验证"
                            className="modal"
                            platform='ios'
                          >
                            <div className="verification-modal">
                              <div id='captcha-mobileregister' className={`${isios ? 'fixios' : ''}`}></div>
                            </div>
                          </Modal>}
                        </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/register/register-form.jsx